var _path, _g, _path2, _g2, _path3, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path10, _g9, _path11, _g10, _path12, _g11, _path13, _g12, _path14, _g13, _path15, _g14, _path16, _g15, _path17, _g16, _path18, _g17, _path19, _g18, _path20, _g19, _path21, _g20, _path22, _g21, _path23, _g22, _path24, _g23, _path25, _g24, _path26, _g25, _path27, _g26, _path28, _g27, _path29, _g28, _path30, _g29, _path31, _g30, _path32, _g31, _path33, _g32, _path34, _g33, _path35, _g34, _path36, _g35, _path37, _g36, _path38, _g37, _path39, _g38, _path40, _g39, _path41, _g40, _path42, _g41, _path43, _g42, _path44, _g43, _path45, _g44, _path46, _g45, _path47, _g46, _path48, _g47, _path49, _g48, _path50, _g49, _path51, _g50, _path52, _g51, _path53, _g52, _path54, _g53, _path55, _g54, _path56, _g55, _path57, _g56, _path58, _g57, _path59, _g58, _path60, _g59, _path61, _g60, _path62, _g61, _path63, _g62, _path64, _g63, _path65, _g64, _path66, _g65, _path67, _g66, _path68, _g67, _path69, _g68, _path70, _g69, _path71, _g70, _path72, _g71, _path73, _g72, _path74, _g73, _path75, _g74, _path76, _g75, _path77, _g76, _path78, _g77, _path79, _g78, _path80, _g79, _path81, _g80, _path82, _g81, _path83, _g82, _path84, _g83, _path85, _g84, _path86, _g85, _path87, _g86, _path88, _g87, _path89, _g88, _path90, _g89, _path91, _g90, _path92, _g91, _path93, _g92, _path94, _g93, _path95, _g94, _path96, _g95, _path97, _g96, _path98, _g97, _path99, _g98, _path100, _g99, _path101, _g100, _path102, _g101, _path103, _g102, _path104, _g103, _path105, _g104, _path106, _g105, _path107, _g106, _path108, _g107, _path109, _g108, _path110, _g109, _path111, _g110, _path112, _g111, _path113, _g112, _path114, _g113, _path115, _g114, _path116, _g115, _path117, _g116, _path118, _g117, _path119, _g118, _path120, _g119, _path121, _g120, _path122, _g121, _path123, _g122, _path124, _g123, _path125, _g124, _path126, _g125, _path127, _g126, _path128, _g127, _path129, _g128, _path130, _g129, _path131, _g130, _path132, _g131, _path133, _g132, _path134, _g133, _path135, _g134, _path136, _g135, _path137, _g136, _path138, _g137, _path139, _g138, _path140, _g139, _path141, _g140, _path142, _g141, _path143, _g142, _path144, _g143, _path145, _g144, _path146, _g145, _path147, _g146, _path148, _g147, _path149, _g148, _path150, _g149, _path151, _g150, _path152, _g151, _path153, _g152, _path154, _g153, _path155, _g154, _path156, _g155, _path157, _g156, _path158, _g157, _path159, _g158, _path160, _g159, _path161, _g160, _path162, _g161, _path163, _g162, _path164, _g163, _path165, _g164, _path166, _g165, _path167, _g166, _path168, _g167, _path169, _g168, _path170, _g169, _path171, _g170, _path172, _g171, _path173, _g172, _path174, _g173, _path175, _g174, _path176, _g175, _path177, _g176, _path178, _g177, _path179, _g178, _path180, _g179, _path181, _g180, _path182, _g181, _path183, _g182, _path184, _g183, _path185, _g184, _path186, _g185, _path187, _g186, _path188, _g187, _path189, _g188, _path190, _g189, _path191, _g190, _path192, _g191, _path193, _g192, _path194, _g193, _path195, _g194, _path196, _g195, _path197, _g196, _path198, _g197, _path199, _g198, _path200, _g199, _path201, _g200, _path202, _g201, _path203, _g202, _path204, _g203, _path205, _g204, _path206, _g205, _path207, _g206, _path208, _g207, _path209, _g208, _path210, _g209, _path211, _g210, _path212, _g211, _path213, _g212, _path214, _g213, _path215, _g214, _path216, _g215, _path217, _g216, _path218, _g217, _path219, _g218, _path220, _g219, _path221, _g220, _path222, _g221, _path223, _g222, _path224, _g223, _path225, _g224, _path226, _g225, _path227, _g226, _path228, _g227, _path229, _g228, _path230, _g229, _path231, _g230, _path232, _g231, _path233, _g232, _path234, _g233, _path235, _g234, _path236, _g235, _path237, _g236, _path238, _g237, _path239, _g238, _path240, _g239, _path241, _g240, _path242, _g241, _path243, _g242, _path244, _g243, _path245, _g244, _path246, _g245, _path247, _g246, _path248, _g247, _path249, _g248, _path250, _g249, _path251, _g250, _path252, _g251, _path253, _g252, _path254, _g253, _path255, _g254, _path256, _g255, _path257, _g256, _path258, _g257, _path259, _g258, _path260, _g259, _path261, _g260, _path262, _g261, _path263, _g262, _path264, _g263, _path265, _g264, _path266, _g265, _path267, _g266, _path268, _g267, _path269, _g268, _path270, _g269, _path271, _g270, _path272, _g271, _path273, _g272, _path274, _g273, _path275, _g274, _path276, _g275, _path277, _g276, _path278, _g277, _path279, _g278, _path280, _g279, _path281, _g280, _path282, _g281, _path283, _g282, _path284, _g283, _path285, _g284, _path286, _g285, _path287, _g286, _path288, _g287, _path289, _g288, _path290, _g289, _path291, _g290, _path292, _g291, _path293, _g292, _path294, _g293, _path295, _g294;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrazil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.68164 10.4745L17.2866 17.8865L28.8976 10.4745L17.2866 3.06348L5.68164 10.4745Z",
    fill: "#EDC226"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_85738)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1795 10.4741C22.1795 13.1761 19.9905 15.3681 17.2865 15.3681C14.5855 15.3681 12.3955 13.1771 12.3955 10.4741C12.3955 7.77411 14.5845 5.5791 17.2865 5.5791C19.9895 5.5781 22.1795 7.77311 22.1795 10.4741Z",
    fill: "#2D146E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4919 8.37598C13.9179 8.37598 13.3569 8.41896 12.8079 8.49496C12.7029 8.73496 12.6169 8.98497 12.5479 9.24297C13.1789 9.13497 13.8268 9.07597 14.4908 9.07597C17.3578 9.07597 19.9789 10.158 21.9579 11.936C22.0379 11.685 22.0968 11.425 22.1318 11.162C20.0658 9.42397 17.4019 8.37598 14.4919 8.37598Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1128 9.04266C13.2258 9.02866 13.3078 8.91467 13.2908 8.78667C13.2768 8.65967 13.1718 8.56667 13.0568 8.58167C12.9398 8.59367 12.8598 8.71066 12.8788 8.83766C12.8928 8.96566 12.9978 9.05766 13.1128 9.04266ZM13.1028 8.95766C13.1678 8.94866 13.2138 8.87666 13.2068 8.79666C13.1968 8.71566 13.1368 8.65767 13.0658 8.66667C12.9978 8.67467 12.9508 8.74566 12.9608 8.82666C12.9728 8.90766 13.0348 8.96566 13.1028 8.95766Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4939 9.00301L13.5779 8.995L13.5659 8.823L13.7549 8.81C13.8309 8.804 13.8919 8.734 13.8899 8.653C13.8819 8.573 13.8119 8.511 13.7339 8.517L13.4639 8.536L13.4939 9.00301ZM13.5599 8.737L13.7399 8.72501C13.7729 8.72101 13.7949 8.69301 13.7949 8.66001C13.7909 8.62601 13.7659 8.601 13.7349 8.605L13.5529 8.61501L13.5599 8.737Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8865 8.9747C13.8825 8.9087 13.8745 8.7627 13.7735 8.7677L13.6465 8.77669C13.7905 8.76769 13.8025 8.91569 13.8105 8.97969",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0861 8.96518L14.3031 8.96018C14.4161 8.95918 14.5021 8.86818 14.5021 8.75618L14.4981 8.69017C14.4961 8.58217 14.4041 8.49217 14.2951 8.49417L14.0781 8.49918L14.0861 8.96518ZM14.1681 8.87618L14.2951 8.87317C14.3651 8.87217 14.4221 8.81418 14.4181 8.74518V8.70317C14.4181 8.63717 14.3611 8.58118 14.2931 8.58118L14.1641 8.58418L14.1681 8.87618Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6719 8.95921L15.0939 8.97421L15.0979 8.8862L14.7599 8.87421L14.7639 8.75621L15.0309 8.76321V8.6842L14.7679 8.67421V8.5822L15.0899 8.5932V8.5052L14.6909 8.49121L14.6719 8.95921Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2676 8.98352L15.3476 8.99052L15.3746 8.67253L15.4376 8.99852L15.5136 9.00552L15.6326 8.69453L15.6046 9.01353L15.6836 9.02052L15.7246 8.55553L15.6106 8.54553L15.4876 8.85553L15.4236 8.52853L15.3066 8.51953L15.2676 8.98352Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2295 9.09271L16.5795 9.15071L16.5895 9.07271L16.3255 9.02771L16.3435 8.92371L16.5625 8.96071L16.5715 8.88071L16.3585 8.84471L16.3685 8.77071L16.6265 8.8157L16.6365 8.73671L16.3045 8.67871L16.2295 9.09271Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1172 9.26643L17.1992 9.28844L17.2462 9.12143L17.4242 9.16644C17.5042 9.18744 17.5842 9.14043 17.6062 9.06143C17.6232 8.98343 17.5772 8.90444 17.5012 8.88144L17.2432 8.81543L17.1172 9.26643ZM17.2702 9.03543L17.4422 9.08144C17.4752 9.09044 17.5052 9.07044 17.5122 9.03844C17.5222 9.00644 17.5002 8.97444 17.4712 8.96544L17.2972 8.92044L17.2702 9.03543Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6895 9.41859L17.7734 9.44359L17.8264 9.27959L18.0005 9.33559C18.0805 9.35959 18.1605 9.31659 18.1855 9.24059C18.2105 9.16359 18.1685 9.08159 18.0915 9.05659L17.8335 8.97559L17.6895 9.41859ZM17.8514 9.19659L18.0234 9.25159C18.0504 9.26059 18.0874 9.24459 18.0974 9.21159C18.1094 9.17959 18.0914 9.14859 18.0584 9.13759L17.8885 9.08258L17.8514 9.19659Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.066 9.5376C18.087 9.4736 18.13 9.3356 18.037 9.3056L17.918 9.2666C18.055 9.3116 18.012 9.4506 17.99 9.5146",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4493 9.67537C18.5583 9.71437 18.6813 9.65138 18.7263 9.53038C18.7733 9.40938 18.7223 9.27837 18.6133 9.23837C18.5043 9.19637 18.3773 9.26138 18.3343 9.38138C18.2873 9.50338 18.3423 9.63337 18.4493 9.67537ZM18.4783 9.59337C18.5443 9.61937 18.6173 9.57438 18.6463 9.49938C18.6753 9.42338 18.6463 9.34338 18.5833 9.31838C18.5183 9.29638 18.4423 9.33738 18.4133 9.41338C18.3853 9.48838 18.4183 9.56937 18.4783 9.59337Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9977 9.89799C19.1027 9.94399 19.2337 9.884 19.2847 9.768C19.3337 9.649 19.2907 9.517 19.1827 9.47C19.0777 9.424 18.9507 9.481 18.8997 9.6C18.8497 9.718 18.8927 9.85199 18.9977 9.89799ZM19.0327 9.817C19.0957 9.846 19.1717 9.80599 19.2027 9.73199C19.2357 9.65799 19.2107 9.57499 19.1497 9.54699C19.0867 9.52099 19.0107 9.55799 18.9797 9.63299C18.9467 9.70799 18.9687 9.791 19.0327 9.817Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1207 9.69531L19.2847 9.76732L19.2537 9.82732L19.0957 9.75531L19.1207 9.69531Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2228 9.73828L19.2848 9.76729L19.1898 9.97928L19.1328 9.95229L19.2228 9.73828Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3496 10.0536L19.4256 10.0916L19.5016 9.93562L19.6676 10.0206C19.7396 10.0566 19.8276 10.0266 19.8626 9.95561C19.8996 9.88261 19.8706 9.79461 19.7976 9.75961L19.5616 9.64062L19.3496 10.0536ZM19.5406 9.85962L19.7006 9.93861C19.7296 9.95461 19.7646 9.94261 19.7806 9.91261C19.7946 9.88361 19.7846 9.84761 19.7556 9.83261L19.5916 9.75262L19.5406 9.85962Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7008 10.2295C19.7298 10.1695 19.7948 10.0385 19.7068 9.99454L19.5918 9.93555C19.7268 10.0025 19.6598 10.1335 19.6328 10.1925",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.875 10.3211L20.242 10.5271L20.281 10.4521L19.988 10.2851L20.045 10.1811L20.277 10.3131L20.316 10.2401L20.086 10.1111L20.133 10.0281L20.408 10.1871L20.455 10.1111L20.103 9.91406L19.875 10.3211Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5565 10.5498C20.5315 10.5878 20.5565 10.6328 20.6115 10.6688C20.6685 10.7038 20.7055 10.7018 20.7225 10.6788C20.7735 10.5968 20.4805 10.4808 20.5705 10.3418C20.6465 10.2218 20.7815 10.3148 20.8325 10.3468C20.8835 10.3788 20.9635 10.4628 20.9005 10.5588L20.8145 10.5028C20.8435 10.4628 20.8145 10.4208 20.7655 10.3958C20.7225 10.3648 20.6875 10.3518 20.6625 10.3958C20.6175 10.4598 20.9085 10.5808 20.8165 10.7208C20.7555 10.8228 20.6405 10.7778 20.5665 10.7308C20.4985 10.6888 20.4045 10.5908 20.4645 10.4948L20.5565 10.5498Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0573 10.8797C21.0283 10.9167 21.0493 10.9627 21.1043 11.0017C21.1593 11.0407 21.2003 11.0427 21.2173 11.0177C21.2703 10.9417 20.9813 10.8077 21.0823 10.6737C21.1663 10.5577 21.2972 10.6577 21.3442 10.6917C21.3952 10.7277 21.4672 10.8157 21.3992 10.9077L21.3193 10.8487C21.3443 10.8087 21.3192 10.7676 21.2742 10.7356C21.2312 10.7056 21.2023 10.6917 21.1723 10.7317C21.1253 10.7937 21.4043 10.9317 21.3113 11.0657C21.2393 11.1657 21.1263 11.1147 21.0573 11.0617C20.9933 11.0167 20.9012 10.9157 20.9692 10.8207L21.0573 10.8797Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5265 11.4164C21.6185 11.4884 21.7555 11.4654 21.8355 11.3644C21.9155 11.2624 21.9075 11.1234 21.8175 11.0514C21.7255 10.9784 21.5885 11.0014 21.5085 11.1034C21.4295 11.2044 21.4375 11.3444 21.5265 11.4164ZM21.5815 11.3474C21.6365 11.3924 21.7205 11.3744 21.7715 11.3104C21.8225 11.2474 21.8145 11.1624 21.7635 11.1204C21.7085 11.0764 21.6285 11.0934 21.5775 11.1574C21.5225 11.2204 21.5265 11.3064 21.5815 11.3474Z",
    fill: "#3C9242"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2906 9.38574L13.2266 9.58475L13.3276 9.61774L13.2906 9.38574Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2908 9.38574L13.3568 9.58475L13.2578 9.61774L13.2908 9.38574Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4902 9.53027H13.2812V9.63327L13.4902 9.53027Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4898 9.53027L13.3238 9.65227L13.2578 9.56827L13.4898 9.53027Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0918 9.53027L13.2618 9.65227L13.3238 9.56827L13.0918 9.53027Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0918 9.53027H13.3028V9.63327L13.0918 9.53027Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4139 9.76445L13.3499 9.56445L13.252 9.59845L13.4139 9.76445Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 9.76466L13.2441 9.64067L13.3072 9.55566L13.4142 9.76466Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.168 9.76466L13.338 9.64067L13.277 9.55566L13.168 9.76466Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.168 9.76445L13.234 9.56445L13.336 9.59845L13.168 9.76445Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7271 11.4424L13.6602 11.6414L13.7621 11.6734L13.7271 11.4424Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7264 11.4424L13.7884 11.6414L13.6904 11.6734L13.7264 11.4424Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask37_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9218 11.5879H13.7148V11.6929L13.9218 11.5879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask38_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9214 11.5879L13.7554 11.7119L13.6924 11.6249L13.9214 11.5879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5273 11.5879L13.6933 11.7119L13.7603 11.6249L13.5273 11.5879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask40_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5273 11.5879H13.7383V11.6929L13.5273 11.5879Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask41_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8496 11.8221L13.7846 11.623L13.6836 11.6551L13.8496 11.8221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8497 11.8223L13.6797 11.6973L13.7397 11.6143L13.8497 11.8223Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask43_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5996 11.8223L13.7726 11.6973L13.7086 11.6143L13.5996 11.8223Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask44_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5996 11.8221L13.6636 11.623L13.7656 11.6551L13.5996 11.8221Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1249 11.9502L13.0859 12.0852L13.1499 12.1062L13.1249 11.9502Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask46_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1245 11.9502L13.1675 12.0852L13.1025 12.1062L13.1245 11.9502Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask47_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2582 12.0488H13.1172V12.1188L13.2582 12.0488Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2575 12.0488L13.1465 12.1318L13.1045 12.0748L13.2575 12.0488Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask49_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9941 12.0488L13.1052 12.1318L13.1472 12.0748L12.9941 12.0488Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask50_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9941 12.0488H13.1331V12.1188L12.9941 12.0488Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2066 12.2043L13.1636 12.0713L13.0996 12.0943L13.2066 12.2043Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask52_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2067 12.2045L13.0957 12.1225L13.1367 12.0645L13.2067 12.2045Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask53_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0449 12.2045L13.1559 12.1225L13.1169 12.0645L13.0449 12.2045Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0449 12.2043L13.0859 12.0713L13.1499 12.0943L13.0449 12.2043Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask55_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2049 11.2529L14.1719 11.3469L14.2189 11.3639L14.2049 11.2529Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask56_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2045 11.2529L14.2335 11.3469L14.1875 11.3639L14.2045 11.2529Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2992 11.3223H14.2012V11.3713L14.2992 11.3223Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask58_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2984 11.3223L14.2184 11.3813L14.1904 11.3403L14.2984 11.3223Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask59_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1064 11.3223L14.1905 11.3813L14.2184 11.3403L14.1064 11.3223Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1064 11.3223H14.2085V11.3713L14.1064 11.3223Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask61_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2635 11.4349L14.2295 11.3379L14.1875 11.3549L14.2635 11.4349Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask62_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2636 11.435L14.1836 11.375L14.2126 11.334L14.2636 11.435Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1465 11.435L14.2265 11.375L14.1965 11.334L14.1465 11.435Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask64_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1465 11.4349L14.1755 11.3379L14.2225 11.3549L14.1465 11.4349Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask65_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7454 11.9639L14.6904 12.1309L14.7694 12.1589L14.7454 11.9639Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7458 11.9639L14.7968 12.1309L14.7168 12.1589L14.7458 11.9639Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask67_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9074 12.0859H14.7334V12.1719L14.9074 12.0859Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask68_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9078 12.0859L14.7678 12.1889L14.7168 12.1159L14.9078 12.0859Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5781 12.0859L14.7191 12.1889L14.7701 12.1159L14.5781 12.0859Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask70_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5781 12.0859H14.7521V12.1719L14.5781 12.0859Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask71_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.848 12.2773L14.793 12.1133L14.709 12.1413L14.848 12.2773Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8481 12.2775L14.7051 12.1765L14.7561 12.1064L14.8481 12.2775Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask73_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6445 12.2775L14.7805 12.1765L14.7296 12.1064L14.6445 12.2775Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask74_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6445 12.2773L14.6945 12.1133L14.7766 12.1413L14.6445 12.2773Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.598 12.4492L14.543 12.6162L14.625 12.6442L14.598 12.4492Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask76_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5974 12.4492L14.6494 12.6162L14.5674 12.6442L14.5974 12.4492Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask77_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7639 12.5713H14.5898V12.6563L14.7639 12.5713Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7643 12.5713L14.6213 12.6743L14.5703 12.6033L14.7643 12.5713Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask79_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4336 12.5713L14.5736 12.6743L14.6246 12.6033L14.4336 12.5713Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask80_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4336 12.5713H14.6066V12.6563L14.4336 12.5713Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6985 12.7666L14.6475 12.5996L14.5645 12.6266L14.6985 12.7666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask82_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6986 12.7668L14.5566 12.6618L14.6106 12.5938L14.6986 12.7668Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask83_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4961 12.7668L14.6371 12.6618L14.5861 12.5938L14.4961 12.7668Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4961 12.7666L14.5491 12.5996L14.6331 12.6266L14.4961 12.7666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask85_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8052 8.74512L18.7402 8.94511L18.8423 8.97612L18.8052 8.74512Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask86_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8045 8.74512L18.8705 8.94511L18.7695 8.97612L18.8045 8.74512Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0039 8.89062H18.7949V8.99661L19.0039 8.89062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask88_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0034 8.89062L18.8335 9.01462L18.7725 8.92862L19.0034 8.89062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask89_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6045 8.89062L18.7765 9.01462L18.8375 8.92862L18.6045 8.89062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6045 8.89062H18.8155V8.99661L18.6045 8.89062Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask91_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9296 9.12675L18.8626 8.92676L18.7656 8.95976L18.9296 9.12675Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask92_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9298 9.12698L18.7578 9.00299L18.8198 8.91699L18.9298 9.12698Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6816 9.12698L18.8516 9.00299L18.7906 8.91699L18.6816 9.12698Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask94_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6816 9.12675L18.7476 8.92676L18.8496 8.95976L18.6816 9.12675Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask95_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7144 11.9824L20.6494 12.1824L20.7514 12.2154L20.7144 11.9824Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7146 11.9824L20.7806 12.1824L20.6836 12.2154L20.7146 11.9824Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask97_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9161 12.1279H20.7051V12.2309L20.9161 12.1279Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask98_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9156 12.1279L20.7476 12.2509L20.6836 12.1649L20.9156 12.1279Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5156 12.1279L20.6876 12.2509L20.7476 12.1649L20.5156 12.1279Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask100_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5156 12.1279H20.7266V12.2309L20.5156 12.1279Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask101_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8438 12.3611L20.7768 12.1621L20.6758 12.1931L20.8438 12.3611Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8439 12.3613L20.6719 12.2383L20.7339 12.1523L20.8439 12.3613Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask103_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5938 12.3613L20.7638 12.2383L20.7007 12.1523L20.5938 12.3613Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask104_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5938 12.3611L20.6577 12.1621L20.7598 12.1931L20.5938 12.3611Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3976 12.0996L21.3516 12.2306L21.4216 12.2526L21.3976 12.0996Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask106_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3981 12.0996L21.4411 12.2306L21.3711 12.2526L21.3981 12.0996Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask107_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5266 12.1953H21.3906V12.2643L21.5266 12.1953Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.527 12.1953L21.416 12.2773L21.375 12.2203L21.527 12.1953Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask109_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2637 12.1953L21.3747 12.2773L21.4197 12.2203L21.2637 12.1953Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask110_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2637 12.1953H21.4037V12.2643L21.2637 12.1953Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4771 12.3518L21.4381 12.2178L21.3691 12.2408L21.4771 12.3518Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask112_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4772 12.3519L21.3652 12.2699L21.4082 12.2119L21.4772 12.3519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask113_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3145 12.3519L21.4254 12.2699L21.3864 12.2119L21.3145 12.3519Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask114_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask114_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3145 12.3518L21.3564 12.2178L21.4214 12.2408L21.3145 12.3518Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask115_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask115_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9162 12.4492L20.8652 12.6162L20.9453 12.6442L20.9162 12.4492Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask116_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask116_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9156 12.4492L20.9686 12.6162L20.8906 12.6442L20.9156 12.4492Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask117_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask117_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0822 12.5713H20.9082V12.6563L21.0822 12.5713Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask118_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask118_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0816 12.5713L20.9446 12.6743L20.8906 12.6033L21.0816 12.5713Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask119_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask119_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.752 12.5713L20.8949 12.6743L20.9449 12.6033L20.752 12.5713Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask120_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask120_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.752 12.5713H20.9259V12.6563L20.752 12.5713Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask121_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask121_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0198 12.7666L20.9668 12.5996L20.8828 12.6266L21.0198 12.7666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask122_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask122_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.0199 12.7668L20.8789 12.6618L20.9299 12.5938L21.0199 12.7668Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask123_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask123_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8145 12.7668L20.9544 12.6618L20.9034 12.5938L20.8145 12.7668Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask124_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask124_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8145 12.7666L20.8665 12.5996L20.9504 12.6266L20.8145 12.7666Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask125_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask125_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7376 13.4756L19.6836 13.6406L19.7656 13.6686L19.7376 13.4756Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask126_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask126_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.738 13.4756L19.791 13.6406L19.707 13.6686L19.738 13.4756Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask127_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask127_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9035 13.5977H19.7295V13.6857L19.9035 13.5977Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask128_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask128_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9039 13.5977L19.7619 13.6987L19.7109 13.6277L19.9039 13.5977Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask129_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask129_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5742 13.5977L19.7152 13.6987L19.7622 13.6277L19.5742 13.5977Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask130_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask130_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5742 13.5977H19.7482V13.6857L19.5742 13.5977Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask131_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask131_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8382 13.792L19.7892 13.626L19.7012 13.652L19.8382 13.792Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask132_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask132_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8383 13.7912L19.6973 13.6882L19.7483 13.6182L19.8383 13.7912Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask133_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask133_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6367 13.7912L19.7767 13.6882L19.7267 13.6182L19.6367 13.7912Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask134_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask134_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6367 13.792L19.6897 13.626L19.7727 13.652L19.6367 13.792Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask135_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask135_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7295 14.0049L19.6895 14.1359L19.7555 14.1579L19.7295 14.0049Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask136_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask136_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.73 14.0049L19.773 14.1359L19.707 14.1579L19.73 14.0049Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask137_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask137_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8626 14.1016H19.7266V14.1706L19.8626 14.1016Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask138_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask138_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.863 14.1016L19.748 14.1816L19.707 14.1256L19.863 14.1016Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask139_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask139_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5996 14.1016L19.7106 14.1816L19.7516 14.1256L19.5996 14.1016Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask140_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask140_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5996 14.1016H19.7376V14.1706L19.5996 14.1016Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask141_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask141_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8132 14.255L19.7702 14.125L19.7012 14.145L19.8132 14.255Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask142_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask142_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8133 14.2542L19.6973 14.1742L19.7403 14.1172L19.8133 14.2542Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask143_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask143_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6494 14.2542L19.7614 14.1742L19.7184 14.1172L19.6494 14.2542Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask144_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask144_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6494 14.255L19.6924 14.125L19.7574 14.145L19.6494 14.255Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask145_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask145_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2267 13.123L20.1797 13.257L20.2437 13.2781L20.2267 13.123Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask146_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask146_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2272 13.123L20.2662 13.257L20.2012 13.2781L20.2272 13.123Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask147_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask147_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3568 13.2207H20.2148V13.2907L20.3568 13.2207Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask148_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask148_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3572 13.2207L20.2442 13.3047L20.2012 13.2487L20.3572 13.2207Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask149_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask149_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0918 13.2207L20.2048 13.3047L20.2438 13.2487L20.0918 13.2207Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask150_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask150_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0918 13.2207H20.2338V13.2907L20.0918 13.2207Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask151_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask151_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3073 13.3761L20.2623 13.2441L20.1973 13.2661L20.3073 13.3761Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask152_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask152_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3064 13.3763L20.1924 13.2953L20.2374 13.2383L20.3064 13.3763Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask153_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask153_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1426 13.3763L20.2556 13.2953L20.2146 13.2383L20.1426 13.3763Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask154_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask154_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1426 13.3761L20.1876 13.2441L20.2516 13.2661L20.1426 13.3761Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask155_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask155_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6165 12.8438L20.5645 13.0088L20.6444 13.0358L20.6165 12.8438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask156_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask156_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6169 12.8438L20.6719 13.0088L20.5859 13.0358L20.6169 12.8438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask157_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask157_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7805 12.9648H20.6064V13.0508L20.7805 12.9648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask158_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask158_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7808 12.9648L20.6447 13.0668L20.5938 12.9948L20.7808 12.9648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask159_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask159_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4512 12.9648L20.5942 13.0668L20.6452 12.9948L20.4512 12.9648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask160_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask160_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4512 12.9648H20.6252V13.0508L20.4512 12.9648Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask161_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask161_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.719 13.1562L20.668 12.9932L20.582 13.0192L20.719 13.1562Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask162_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask162_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7191 13.1564L20.5781 13.0554L20.6291 12.9844L20.7191 13.1564Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask163_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask163_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5137 13.1564L20.6577 13.0554L20.6027 12.9844L20.5137 13.1564Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask164_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask164_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5137 13.1562L20.5697 12.9932L20.6497 13.0192L20.5137 13.1562Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask165_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask165_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7148 13.0303L19.6758 13.1633L19.7398 13.1853L19.7148 13.0303Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask166_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask166_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7144 13.0303L19.7614 13.1633L19.6924 13.1853L19.7144 13.0303Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask167_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask167_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8529 13.1289H19.7109V13.1979L19.8529 13.1289Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask168_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask168_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8533 13.1289L19.7383 13.2099L19.6973 13.1519L19.8533 13.1289Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask169_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask169_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5859 13.1289L19.6969 13.2099L19.7379 13.1519L19.5859 13.1289Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask170_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask170_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5859 13.1289H19.7269V13.1979L19.5859 13.1289Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask171_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask171_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8025 13.2854L19.7574 13.1504L19.6895 13.1714L19.8025 13.2854Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask172_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask172_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8025 13.2855L19.6875 13.2005L19.7265 13.1475L19.8025 13.2855Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask173_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask173_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6367 13.2855L19.7477 13.2005L19.7067 13.1475L19.6367 13.2855Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask174_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask174_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6367 13.2854L19.6797 13.1504L19.7477 13.1714L19.6367 13.2854Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask175_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask175_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4242 10.5L15.3691 10.665L15.4532 10.691L15.4242 10.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask176_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask176_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4236 10.5L15.4765 10.665L15.3945 10.691L15.4236 10.5Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask177_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask177_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.59 10.6191H15.416V10.7061L15.59 10.6191Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask178_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask178_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5894 10.6191L15.4485 10.7242L15.3975 10.6511L15.5894 10.6191Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask179_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask179_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2559 10.6191L15.3979 10.7242L15.4489 10.6511L15.2559 10.6191Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask180_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask180_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2559 10.6191H15.4298V10.7061L15.2559 10.6191Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask181_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask181_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5246 10.8144L15.4746 10.6494L15.3906 10.6764L15.5246 10.8144Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask182_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask182_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5248 10.8146L15.3828 10.7126L15.4338 10.6416L15.5248 10.8146Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask183_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask183_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3174 10.8146L15.4624 10.7126L15.4114 10.6416L15.3174 10.8146Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask184_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask184_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3174 10.8144L15.3744 10.6494L15.4544 10.6764L15.3174 10.8144Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask185_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask185_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6171 10.0869L18.5781 10.2209L18.6431 10.2409L18.6171 10.0869Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask186_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask186_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6167 10.0869L18.6637 10.2209L18.5957 10.2409L18.6167 10.0869Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask187_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask187_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7543 10.1855H18.6133V10.2535L18.7543 10.1855Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask188_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask188_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7536 10.1855L18.6386 10.2675L18.5996 10.2105L18.7536 10.1855Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask189_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask189_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4863 10.1855L18.6003 10.2675L18.6393 10.2105L18.4863 10.1855Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask190_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask190_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4863 10.1855H18.6293V10.2535L18.4863 10.1855Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask191_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask191_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7028 10.342L18.6558 10.208L18.5918 10.23L18.7028 10.342Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask192_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask192_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7029 10.3412L18.5879 10.2572L18.6289 10.2002L18.7029 10.3412Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask193_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask193_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5371 10.3412L18.6501 10.2572L18.6091 10.2002L18.5371 10.3412Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask194_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask194_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5371 10.342L18.5801 10.208L18.6471 10.23L18.5371 10.342Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask195_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask195_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2867 12.4619L17.2207 12.6609L17.3217 12.6939L17.2867 12.4619Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask196_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask196_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2869 12.4619L17.3519 12.6609L17.2539 12.6939L17.2869 12.4619Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask197_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask197_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4863 12.6055H17.2793V12.7115L17.4863 12.6055Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask198_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask198_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4858 12.6055L17.3178 12.7305L17.2578 12.6445L17.4858 12.6055Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask199_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask199_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0879 12.6055L17.2619 12.7305L17.3179 12.6445L17.0879 12.6055Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask200_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask200_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0879 12.6055H17.2969V12.7115L17.0879 12.6055Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask201_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask201_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4101 12.8416L17.3481 12.6436L17.2461 12.6746L17.4101 12.8416Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask202_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask202_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4102 12.8418L17.2422 12.7178L17.3012 12.6338L17.4102 12.8418Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask203_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask203_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1641 12.8418L17.3341 12.7178L17.2721 12.6338L17.1641 12.8418Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask204_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask204_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1641 12.8416L17.2281 12.6436L17.33 12.6746L17.1641 12.8416Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask205_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask205_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8548 11.5244L17.8008 11.6904L17.8848 11.7164L17.8548 11.5244Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask206_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask206_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8552 11.5244L17.9102 11.6904L17.8262 11.7164L17.8552 11.5244Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask207_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask207_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0197 11.6455H17.8438V11.7305L18.0197 11.6455Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask208_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask208_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0202 11.6455L17.8772 11.7475L17.8262 11.6775L18.0202 11.6455Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask209_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask209_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6895 11.6455L17.8294 11.7475L17.8805 11.6775L17.6895 11.6455Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask210_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask210_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6895 11.6455H17.8625V11.7305L17.6895 11.6455Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask211_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask211_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9573 11.8408L17.9023 11.6738L17.8203 11.7018L17.9573 11.8408Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask212_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask212_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9564 11.841L17.8154 11.737L17.8664 11.666L17.9564 11.841Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask213_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask213_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 11.841L17.893 11.737L17.842 11.666L17.75 11.841Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask214_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask214_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 11.8408L17.805 11.6738L17.889 11.7018L17.75 11.8408Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask215_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask215_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2864 11.0869L17.2314 11.2509L17.3155 11.2779L17.2864 11.0869Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask216_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask216_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2867 11.0869L17.3397 11.2509L17.2617 11.2779L17.2867 11.0869Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask217_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask217_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4533 11.2051H17.2793V11.2931L17.4533 11.2051Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask218_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask218_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4527 11.2051L17.3127 11.3071L17.2617 11.2371L17.4527 11.2051Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask219_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask219_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.123 11.2051L17.2661 11.3071L17.313 11.2371L17.123 11.2051Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask220_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask220_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.123 11.2051H17.2971V11.2931L17.123 11.2051Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask221_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask221_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3909 11.4004L17.3379 11.2344L17.2539 11.2604L17.3909 11.4004Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask222_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask222_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.391 11.4006L17.25 11.2986L17.301 11.2266L17.391 11.4006Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask223_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask223_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1846 11.4006L17.3256 11.2986L17.2746 11.2266L17.1846 11.4006Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask224_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask224_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1846 11.4004L17.2376 11.2344L17.3216 11.2604L17.1846 11.4004Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask225_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask225_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.793 11.5596L16.75 11.6926L16.818 11.7146L16.793 11.5596Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask226_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask226_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7925 11.5596L16.8395 11.6926L16.7715 11.7146L16.7925 11.5596Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask227_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask227_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9281 11.6553H16.7891V11.7243L16.9281 11.6553Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask228_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask228_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9275 11.6553L16.8145 11.7373L16.7715 11.6803L16.9275 11.6553Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask229_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask229_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 11.6553L16.7751 11.7373L16.8151 11.6803L16.6641 11.6553Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask230_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask230_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6641 11.6553H16.8011V11.7243L16.6641 11.6553Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask231_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask231_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8766 11.8127L16.8356 11.6797L16.7676 11.7007L16.8766 11.8127Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask232_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask232_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8766 11.8128L16.7656 11.7298L16.8086 11.6738L16.8766 11.8128Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask233_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask233_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 11.8128L16.8258 11.7298L16.7849 11.6738L16.7148 11.8128Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask234_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask234_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 11.8127L16.7578 11.6797L16.8218 11.7007L16.7148 11.8127Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask235_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask235_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0427 11.9385L17.0117 12.0335L17.0587 12.0485L17.0427 11.9385Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask236_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask236_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0424 11.9385L17.0714 12.0335L17.0244 12.0485L17.0424 11.9385Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask237_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask237_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1371 12.0078H17.0371V12.0578L17.1371 12.0078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask238_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask238_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1373 12.0078L17.0593 12.0668L17.0293 12.0258L17.1373 12.0078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask239_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask239_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9453 12.0078L17.0293 12.0668L17.0593 12.0258L16.9453 12.0078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask240_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask240_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9453 12.0078H17.0473V12.0578L16.9453 12.0078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask241_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask241_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0975 12.1204L17.0675 12.0244L17.0215 12.0394L17.0975 12.1204Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask242_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask242_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0976 12.1205L17.0176 12.0605L17.0506 12.0195L17.0976 12.1205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask243_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask243_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9814 12.1205L17.0624 12.0605L17.0324 12.0195L16.9814 12.1205Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask244_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask244_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9814 12.1204L17.0154 12.0244L17.0624 12.0394L16.9814 12.1204Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask245_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask245_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7542 13.5947L18.6992 13.7617L18.7832 13.7897L18.7542 13.5947Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask246_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask246_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7537 13.5947L18.8087 13.7617L18.7227 13.7897L18.7537 13.5947Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask247_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask247_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9182 13.7148H18.7441V13.8048L18.9182 13.7148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask248_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask248_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9176 13.7148L18.7766 13.8188L18.7266 13.7468L18.9176 13.7148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask249_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask249_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5879 13.7148L18.7269 13.8188L18.7809 13.7468L18.5879 13.7148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask250_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask250_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5879 13.7148H18.7619V13.8048L18.5879 13.7148Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask251_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask251_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8548 13.9111L18.8008 13.7441L18.7188 13.7721L18.8548 13.9111Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask252_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask252_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8549 13.9113L18.7148 13.8093L18.7658 13.7383L18.8549 13.9113Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask253_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask253_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6494 13.9113L18.7904 13.8093L18.7394 13.7383L18.6494 13.9113Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask254_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask254_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6494 13.9111L18.7024 13.7441L18.7864 13.7721L18.6494 13.9111Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask255_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask255_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 13.1973L19.1289 13.3303L19.1929 13.3533L19.1719 13.1973Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask256_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask256_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1715 13.1973L19.2145 13.3303L19.1465 13.3533L19.1715 13.1973Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask257_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask257_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3051 13.2959H19.1641V13.3619L19.3051 13.2959Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask258_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask258_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3044 13.2959L19.1924 13.3759L19.1494 13.3209L19.3044 13.2959Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask259_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask259_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0371 13.2959L19.1501 13.3759L19.1931 13.3209L19.0371 13.2959Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask260_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask260_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0371 13.2959H19.1801V13.3619L19.0371 13.2959Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask261_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask261_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2535 13.4494L19.2105 13.3164L19.1465 13.3394L19.2535 13.4494Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask262_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask262_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2536 13.4495L19.1426 13.3675L19.1836 13.3105L19.2536 13.4495Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask263_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask263_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0918 13.4495L19.2028 13.3675L19.1598 13.3105L19.0918 13.4495Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask264_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask264_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0918 13.4494L19.1348 13.3164L19.2008 13.3394L19.0918 13.4494Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask265_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask265_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3672 13.0771L18.3242 13.2092L18.3892 13.2321L18.3672 13.0771Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask266_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask266_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3667 13.0771L18.4097 13.2092L18.3457 13.2321L18.3667 13.0771Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask267_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask267_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4974 13.1738H18.3584V13.2448L18.4974 13.1738Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask268_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask268_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4977 13.1738L18.3847 13.2578L18.3457 13.1988L18.4977 13.1738Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask269_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask269_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2314 13.1738L18.3455 13.2578L18.3845 13.1988L18.2314 13.1738Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask270_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask270_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2314 13.1738H18.3745V13.2448L18.2314 13.1738Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask271_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask271_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4489 13.3303L18.4059 13.1973L18.3379 13.2203L18.4489 13.3303Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask272_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask272_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.449 13.3304L18.334 13.2484L18.377 13.1924L18.449 13.3304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask273_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask273_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2832 13.3304L18.3972 13.2484L18.3552 13.1924L18.2832 13.3304Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask274_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask274_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2832 13.3303L18.3262 13.1973L18.3972 13.2203L18.2832 13.3303Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask275_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask275_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3217 12.8604L15.2598 13.0594L15.3568 13.0924L15.3217 12.8604Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask276_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask276_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3221 12.8604L15.3871 13.0594L15.2891 13.0924L15.3221 12.8604Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask277_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask277_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5244 13.0078H15.3145V13.1118L15.5244 13.0078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask278_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask278_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.525 13.0078L15.352 13.1298L15.293 13.0448L15.525 13.0078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask279_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask279_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1211 13.0078L15.2971 13.1298L15.3531 13.0448L15.1211 13.0078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask280_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask280_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1211 13.0078H15.3321V13.1118L15.1211 13.0078Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask281_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask281_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4452 13.241L15.3831 13.043L15.2852 13.074L15.4452 13.241Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask282_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask282_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4453 13.2402L15.2773 13.1172L15.3363 13.0322L15.4453 13.2402Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask283_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask283_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1992 13.2402L15.3692 13.1172L15.3072 13.0322L15.1992 13.2402Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask284_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask284_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1992 13.241L15.2682 13.043L15.3652 13.074L15.1992 13.241Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask285_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask285_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2866 14.2314L17.2656 14.2995L17.2966 14.3105L17.2866 14.2314Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask286_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask286_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2873 14.2314L17.3093 14.2995L17.2793 14.3105L17.2873 14.2314Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask287_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask287_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3552 14.2812H17.2832V14.3152L17.3552 14.2812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask288_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask288_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3553 14.2812L17.2973 14.3223L17.2793 14.2933L17.3553 14.2812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask289_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask289_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2207 14.2812L17.2787 14.3223L17.2967 14.2933L17.2207 14.2812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask290_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask290_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2207 14.2812H17.2887V14.3152L17.2207 14.2812Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask291_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask291_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3254 14.359L17.3084 14.293L17.2744 14.305L17.3254 14.359Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask292_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask292_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3255 14.359L17.2715 14.319L17.2885 14.292L17.3255 14.359Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask293_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask293_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2461 14.359L17.3011 14.319L17.2831 14.292L17.2461 14.359Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask294_11472_85738",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 21
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0688 0.685547H0.505859V20.2625H34.0688V0.685547Z",
    fill: "white"
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask294_11472_85738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2461 14.359L17.2701 14.293L17.3011 14.305L17.2461 14.359Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazil);
export default __webpack_public_path__ + "static/media/BRAZIL.94e17c898052d46dd3a8806a621691c2.svg";
export { ForwardRef as ReactComponent };